import * as URIJS from 'urijs'

const parseQuery = <T>(queryString: string): T => URIJS.parseQuery(queryString) as unknown as T

export { parseQuery }
